<template>
    <div class="modal fade" id="modalCNH" tabindex="-1" role="dialog" aria-labelledby="modalCNH" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="confirmationModalLabel">{{$t('response.trucker.aprove.fleet.driver.title')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
					<p class="pre-line">
						{{$t('response.trucker.aprove.document.description')}}
					</p>
                    <span class="pre-line" v-if="data.item && data.item.customerUser">
						{{$t('string.trucker.label.name')}} 	{{data.item.firstName + ' ' + data.item.lastName}}
					</span><br>
                    <br/><br>
                    <div class="d-flex justify-content-center">
                    <img v-if="data.item && data.item.customerUser"  v-bind:src="`${domain}${data.item.customerUser.cnhPhotoURL}`" alt="image" height="450" width="600">
                    </div>
                    
				</div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="$emit('confirmation-return', 0)">{{$t('string.msg.term.btn.cancel')}}</button>
                    <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="save()">{{$t('string.msg.term.btn.aprove')}}</button>
                    <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="reject()">{{$t('string.msg.term.btn.reject')}}</button>
                </div>
               
            </div>
        </div>
           <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" v-on:confirmation-return="save"/>
           <FlashMessage/>
    </div>
</template>
<script>

    import Controller from './CrtModalPhoto';
    import Confirmation from '../../../../../components/layout/Confirmation';
    export default {
        props: ["item"],
        watch:{
            'item'(){
                this.data.item = this.item;
            }
        },
        components: {
            Confirmation
        },
        data() {
            return {
                errors: [],
                titleToast: null,
                messageToast: null,
                messageIdToast: null,
                data: {
                    item: {},
                }
            }
        },
        methods: Controller.methods,
        created() {
            
        },
        mounted(){
            Controller.init(this);
        }
    }
</script>

